<template>
  <div class="dialog">
    <div class="dialog-header">
      <p class="dialog-title text-uppercase mb-0">EDIT LIVE BROADCAST</p>
    </div>
    <div class="dialog-content">
      <b-container class="mt-3">
        <b-form @submit="onSubmit">
          <b-form-group label="Start Time:">
            <b-form-input id="startTime"
                          type="time"
                          min="00:00"
                          max="24:00"
                          v-model="startTime">
            </b-form-input>
          </b-form-group>
          <div class="d-flex justify-content-end">
            <b-button class="text-center"
                      type="submit"
                      variant="outline-primary"
                      :disabled="!hasChanges">
              Submit
            </b-button>
            <b-button class="text-center ml-1"
                      variant="outline-danger"
                      @click="closeModal">
              Cancel
            </b-button>
          </div>
        </b-form>
      </b-container>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import moment from 'moment-timezone';

  export default {
    name  : 'EditLiveBroadcast',
    props : {
      data : Object,
    },
    data() {
      return {
        startTime   : this.data.start_time,
        broadcastId : this.data.live_broadcast_id,
        userTZ      : this.$store.getters['user/user'].timezone,
      }
    },
    computed : {
      hasChanges() {
        return this.data.start_time !== this.startTime;
      },
    },
    methods : {
      ...mapActions({
        getScheduledLiveBroadcast : 'broadcast/getScheduledLiveBroadcast',
      }),

      /**
       * Submit Form
       * @param e
       */
      onSubmit(e) {
        e.preventDefault();

        // set default time zone
        moment.tz.setDefault(this.userTZ);

        const today = new Date();
        const todayUTC = moment.utc(today);
        const todayUserTz = moment.tz(todayUTC, this.userTZ);

        const start = todayUserTz.format('YYYY-MM-DD') + ' ' +
          this.startTime + ':00';
        const startUTC = moment.utc(moment(start));
        const startUserTz = moment.tz(startUTC, this.userTZ);
        
        const startMilli = parseInt(startUserTz.format('x'));
        const todayMilli = parseInt(todayUserTz.format('x'));
        
        const diff = this.calculateTimeDiff(startMilli, todayMilli);

        if (startMilli > todayMilli) {
          this.$http.put('api/live_broadcast', {
            'liveBroadcastId' : this.broadcastId,
            'updateFields'    : {
              'start_time'         : startUTC.format('YYYY-MM-DD HH:mm:ss A'),
              'start_time_user_tz' :
                startUserTz.format('YYYY-MM-DD HH:mm:ss A'),
            },
            'action'   : 'scheduled',
            'timeLeft' : diff,
          }).then(() => {
            this.getScheduledLiveBroadcast();
            this.$notify({
              group : 'notif',
              type  : 'success',
              title : 'Success!',
              text  : 'Edited live broadcast successfully.',
            });
            this.closeModal();
          }).catch(() => {
            this.$notify({
              group : 'notif',
              type  : 'error',
              title : 'Failed',
              text  : 'Oops! Something went wrong!',
            });
          });
        } else {
          this.$notify({
            group : 'notif',
            type  : 'error',
            title : 'Failed',
            text  : `Start Time must not be the same or later than
              current time`,
          });
        }
        
      },

      /**
       * Close Modal
       */
      closeModal() {
        this.$emit('modalClose');
        this.$emit('close');
      },

      /**
       * Caculate Time Diff
       * @param startTime
       * @param currenTime
       * @return {string}
       */
      calculateTimeDiff(startTime, currentTime) {
        const diff = startTime - currentTime;

        let minutes = Math.floor((diff / (1000 * 60)) % 60);
        let hours = Math.floor((diff / (1000 * 60 * 60)) % 24);

        const hoursTxt = (hours > 1) ? ' hours' : ' hour';
        const minutesTxt = (minutes > 1) ? ' minutes' : ' minute';

        hours = (hours > 0) ? hours + hoursTxt : '';
        minutes = (minutes > 0) ? minutes + minutesTxt : '';

        return hours + ' ' + minutes;
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/components/admin/broadcast/edit-live-broadcast";
</style>